export const endpoints = {
  // Customer
  /**
   * @deprecated This endpoint is deprecated and should not be used in new features
   * Use the new customer endpoint`
   */
  clients: '/cliente/v2/ListClienteEstruturaComl',
  customers: '/cliente/v2/estruturacomercial/listar-clientes',
  // Key Accounts
  keyAccounts: '/cliente/v2/clientes-especiais',
  keyAccountsTracking: '/cliente/v2/clientes-especiais/trackings',
  // Backoffice
  backofficeClustersMaterials: '/backoffice/v2/clusters/materials',
  backofficeClustersUpload: '/backoffice/v2/clusters/upload',
  backofficeClustersIssuesDownloadExcel: '/backoffice/v2/clusters/issues', // NOTE: /backoffice/v2/clusters/issues/{processId}/excel
  backofficeClustersDownloadExcel: '/backoffice/v2/clusters/excel',
  backofficeClusters: '/backoffice/v2/clusters',
  backofficeClustersTracking: '/backoffice/v2/clusters/tracking'
} as const
